import React from "react"
import styles from "./contactUs.module.scss"
import closeButton from "images/instance_closeButton.png"
import ChatIcon from '@mui/icons-material/Chat';
import Fab from '@mui/material/Fab';

const ContactUs = (props) => {
  const form = document.getElementById("formMask");

  const closeForm = () => {
    form.style.display = "none";
  }

  const openForm = () => {
    form.style.display = "block";
  }

  const formRender = () => {
    switch (props.searchParams.get("lang")) {
      case 'en':
        return <iframe title="Form" width="100%" height="100%" src="https://www.surveycake.com/s/LPnNR"></iframe>
      default:
        return <iframe title="Form" width="100%" height="100%" src="https://www.surveycake.com/s/1OZAx"></iframe>
    }
  }

  return (
    <>
      <div id="formMask" className={styles.mask}>
        <div className={styles.form}>
          {formRender()}
          <img onClick={closeForm} className={styles.closeButton} alt='closeButton' src={closeButton} />
        </div>
      </div>
      <Fab onClick={openForm} className={styles.fabCircle} color="primary" aria-label="add">
        <ChatIcon htmlColor="white" />
      </Fab>
      <button onClick={openForm} className={styles.fab}>{props.searchParams.get("lang") === 'en' ?
        <span style={{ transform: "rotate(180deg)", writingMode: 'vertical-lr' }}>
          Contact Us
        </span>
        : '聯絡我們'}
      </button>
    </>
  );
}

export default ContactUs
